<template>
  <div class="login">
    <div class="mobile-title" style="display: none;">
      <!-- <img src="../assets/img/logo.png" class="logo"/> -->
      <p class="title">登录中心</p>
    </div>
    <div class="bg"></div>
    <div class="content">
      <div>
        <img src="../assets/img/logo.png" class="logo"/>
        <p class="title">登录远大小状元</p>
      </div>
      <div>
        <p class="id_title" v-if="identityStr">登录身份：{{ identityStr }}</p>
        <el-input v-model.trim="username" type="text" size="large"  placeholder="请输入账号" clearable ></el-input>
        <el-input v-model.trim="password" type="password" size="large" placeholder="请输入密码" clearable show-password @keyup.enter="loginFn"></el-input>
        <div>
          <el-checkbox v-model="isRemember" @change="changeRememberMe">记住密码</el-checkbox>
          <!-- https://www.k12china.com/h5/reg/login/#/cloudjoin  大学云登录 -->
          <span @click="register">注册账号</span>  
          <span @click="forgetPwd">忘记密码?</span>
        </div>
        
        <el-button size="large" type="primary" @click="loginFn">立 即 登 录</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import DES from '../assets/js/DES'
import { getUrlQuery, encrypt, decrypt } from '../utils/utils'
import { reqCode, login } from '../request/api'

export default {
  mounted(){
    let identity = getUrlQuery().identity;
    if(identity !== ""){
      this.identityStr = identity === "S" ? "学生" : identity === "T" ? "老师" : "";
    }
    
    const localRem = JSON.parse(localStorage.getItem('rememberUser')) || {}
    if(localRem.isCheck){
      this.isRemember = true
      this.username = localRem.username
      this.password = decrypt(localRem.password)
    }
  },

  data(){
    return {
      username: '',
      password: '',
      isRemember: false,
      identityStr: ''
    }
  },
  methods: {
    async getCode(){ 
      let [err, data] = await reqCode({ name: this.username })
      if(err){
        this.$message.error(err.message)
        return
      }
      return data
    },
    async loginFn(){
      if(this.username == '' || this.password == ''){
        this.$message.warning('账号密码不能为空!')
        return
      }

      // 获取code
      let {code} = await this.getCode()

      // 获取地址栏参数
      let { identity, callback, needKey, needUserId } = getUrlQuery()

      let params = {
        key: '',
        name: this.username,
        password: DES.yd_login_code(this.password, code),
        code,
        identity,
        from: 'pc',
        platform: 'common-login'
      }
      let [err, data, headers] = await login(params)
      if(err){
        this.$message.error(err.message)
        return
      }
      if(data.code === 202){
        this.$message.success('登录成功!')
        let key = headers['x-auth-token'].slice(1)  // 去除前面一个空格
        window.open(`${callback}?identity=${identity}${ needKey == 'T' && ('&key='+key + '&token='+key)}${needUserId? '&new_userId='+data.user_id:''}${'&t=' + new Date().getTime()}`, "_self")
      }else{
        this.$message.error(data.message)
      }
      this.changeRememberMe()
    },
    changeRememberMe(){
      if(this.isRemember){
        let rememberUser = {
          username: this.username,
          password: encrypt(this.password),
          isCheck: this.isRemember,
        }
        localStorage.setItem('rememberUser', JSON.stringify(rememberUser))
      }else{
        localStorage.removeItem('rememberUser')
      }
    },
    register() {
      window.open(`https://www.k12china.com/h5/reg/login/#/cloudjoin`, '_blank');
    },
    forgetPwd(){
      window.open(`https://www.k12china.com/h5/reg/login/#/cloudlost`, '_blank');
      // var myhref = window.location.href
      // let openUrl = 'https://www.k12china.com/h5/pw/index.html'
      // let {callback} = getUrlQuery()
      // if (
      //   myhref.includes('localhost') ||
      //   myhref.includes('192.168.20.20') ||
      //   myhref.includes('127.0.0.1')) {
      //     openUrl = 'http://192.168.20.20:8082'
      //   }else if (
      //     myhref.includes('192.168.6.32') ||
      //     myhref.includes('http://192.168.6.32')
      //   ) {
      //     openUrl = 'http://192.168.20.20:8082'
      //   }
      // window.open(`${openUrl}?callback=${callback}`, '_self')
    }
  }
}
</script>

<style lang='scss' scoped>
.login {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(0deg,#029ae9,#409eff);
  .bg {
    width: 80%;
    height: 80%;
    background-position: top;
    background-repeat: no-repeat;
    background-image: url('../assets/img/bg.png');
  }
  .content {
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: absolute;
    z-index: 10;
    width: 60%;
    height: 37%;
    min-width: 800px;
    max-width: 900px;
    min-height: 25rem;
    background: hsla(0,0%,100%,.9);
    border-radius: 1rem;
    .logo {
      display: inline-block;
      width: 55%;
    }
    .title {
      font-size: 3rem;
      font-family: SimHei;
      line-height: 7rem;
      color: #999;
      text-align: center;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    > div{
      display: inline-flex;
      align-items: center;
      flex-direction: column;
      width: 49.5%;
      height: 75%;
      flex-grow: 0;
      cursor: pointer;
      .id_title {
        color: #606266;
        font-size: 18px;
      }
    }
    > div:first-child {
      justify-content: center;
      box-shadow: inset -2px 0 0 0 #ccc;
    }
    > div:last-child {
      justify-content: space-around;
      .el-input, .el-button, div {
        width: 80%;
        font-size: 1.2rem;
      }
      div{
        display: flex;
        justify-content: space-between;
        align-items: center;
        span{
            font-size: 14px;
            color: #999;
          }
      }
      .el-checkbox {
        align-self: flex-start;
        margin-left: 10px;
        transform: scale(1.3);
      }
    }
  }

  @media screen and (max-width: 700px) {
    .mobile-title{
      display: inline-block !important;
      // width: 55%;
      position: absolute;
      top: 50px;
      left: 50%;
      transform: translateX(-50%);
      // font-size: 2rem;
      // font-family: SimHei;
      // line-height: 7rem;
      // color: #999;
      // text-align: center;
      // white-space: nowrap;
      // text-overflow: ellipsis;
      // overflow: hidden;
      .title{
        font-size: 2.5rem;
        font-family: SimHei;
        line-height: 7rem;
        color: #FFF;
        text-align: center;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .content>div:first-child{
      display: none;
    }
    .content{
      min-width: 100%;
      min-height: 22rem;
      > div:last-child {
        width: 90%;
        .el-input, .el-button, div{
          width: 100%;
          font-size: 1.2rem;
        }
        .el-checkbox{
          margin-left: 13px;
        }
      }
    }
  }
}
</style>
<style lang='scss'>
.el-input {
  .el-input__inner{
    height: 3rem;
  }
}
</style>